import { render, staticRenderFns } from "./QuoteInfo.vue?vue&type=template&id=b1f85ed6&"
import script from "./QuoteInfo.vue?vue&type=script&lang=js&"
export * from "./QuoteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports